"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgShare06 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.337 3.14a1.5 1.5 0 0 1 1.2-.552c.407.01.714.213.868.323a8.287 8.287 0 0 1 .566.462l8.49 7.277c.105.09.227.194.324.293.11.113.266.292.358.55a1.5 1.5 0 0 1 0 1.014 1.514 1.514 0 0 1-.358.55c-.098.1-.219.203-.323.293l-8.518 7.3a8.27 8.27 0 0 1-.539.439c-.154.11-.461.313-.868.323a1.5 1.5 0 0 1-1.2-.552c-.257-.315-.302-.68-.319-.87a8.277 8.277 0 0 1-.018-.693v-3.1a10.4 10.4 0 0 0-6.23 3.605A1 1 0 0 1 2 19.163v-.612a10.667 10.667 0 0 1 8-10.322V4.703c0-.245 0-.492.018-.693.017-.19.062-.555.32-.87Z", fill: "currentColor" }) }))); };
exports.default = SvgShare06;
